import { render, staticRenderFns } from "./transferQuantity.vue?vue&type=template&id=9b893014&"
import script from "./transferQuantity.vue?vue&type=script&lang=js&"
export * from "./transferQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports